var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: " currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12.272 15.737 4.06 2.538c2.839-4.409-.52-8.577-.52-8.577L17.3 7.45c1.302.04 2.625-.61 3.412-1.798l-6.285-3.928c-.787 1.188-.837 2.613-.27 3.762L12.67 7.734S7.3 6.448 4.46 10.856l5.936 3.71m1.876 1.171-1.876-1.172m1.876 1.172.002.001-1.878-1.173m1.876 1.172L6.714 20.49l1.805-7.097 1.877 1.173"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIn);
export default __webpack_public_path__ + "static/media/pin_in.453b6b450e2aad912d2806d1db89f184.svg";
export { ForwardRef as ReactComponent };